import RtkQueryService from '@lok/services/RtkQueryService';

import { transformErrorResponse } from '../api';

const commonFields = [
  'id',
  'slug',
  'description',
  'thread',
  'created_at',
  'created_by.id',
  'created_by.nickname',
  'created_by.first_name'
];

const threadFields = [
  'topic',
  'num_comments',
  'num_likes',
  'is_pinned',
  'is_read'
];

const thredService = RtkQueryService.injectEndpoints({
  endpoints: (builder) => ({
    fetchSingleBoard: builder.query({
      query: (payload) => {
        const boardSlug =
          typeof payload === 'string'
            ? payload
            : payload?.boardSlug;
        const ordering =
          typeof payload === 'string'
            ? '-created_at'
            : payload?.ordering || '-created_at';

        return {
          url: `/v1/boards/${boardSlug}/threads/`,
          params: {
            expand: 'created_by',
            fields: [...commonFields, ...threadFields].join(','),
            page_size: 1000,
            ordering
          }
        };
      },
      providesTags: (result) =>
        result?.results
          ? [
              ...result.results.map(({ id }) => ({
                type: 'Thread',
                id
              })),
              'Thread'
            ]
          : ['Thread'],
      transformErrorResponse
    }),
    fetchSingleThread: builder.query({
      query: (payload) => ({
        url: `/v1/boards/${payload.boardSlug}/threads/${payload.threadSlug}/`,
        params: {
          expand: 'created_by,board',
          fields:
            'id,slug,topic,description,created_by.id,created_by.nickname,created_by.first_name'
        }
      }),
      provideTags: ['Thread'],
      transformErrorResponse
    }),
    createNewThread: builder.mutation({
      query: (payload) => ({
        url: `/v1/boards/${payload.boardSlug}/threads/`,
        method: 'POST',
        data: payload
      }),
      invalidatesTags: ['Thread'],
      transformErrorResponse
    }),
    updateThread: builder.mutation({
      query: ({ boardSlug, threadSlug, ...data }) => ({
        url: `/v1/boards/${boardSlug}/threads/${threadSlug}/`,
        method: 'PATCH',
        data
      }),
      invalidatesTags: ['Thread'],
      transformErrorResponse
    }),
    deleteThread: builder.mutation({
      query: ({ boardSlug, threadSlug }) => ({
        url: `/v1/boards/${boardSlug}/threads/${threadSlug}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Thread'],
      transformErrorResponse
    }),
    markThreadAsRead: builder.mutation({
      query: ({ boardSlug, threadSlug }) => ({
        url: `/v1/boards/${boardSlug}/threads/${threadSlug}/read/`,
        method: 'POST'
      }),
      invalidatesTags: ['UnreadTotal'],
      transformErrorResponse
    }),
    toggleThreadPin: builder.mutation({
      query: ({ boardSlug, threadSlug }) => ({
        url: `/v1/boards/${boardSlug}/threads/${threadSlug}/pin/`,
        method: 'POST'
      }),
      transformErrorResponse
    }),
    toggleThreadLike: builder.mutation({
      query: ({ boardSlug, threadSlug }) => ({
        url: `/v1/boards/${boardSlug}/threads/${threadSlug}/like/`,
        method: 'POST'
      }),
      transformErrorResponse
    })
  })
});

export const {
  useFetchSingleBoardQuery,
  useFetchSingleThreadQuery,
  useCreateNewThreadMutation,
  useUpdateThreadMutation,
  useDeleteThreadMutation,
  useMarkThreadAsReadMutation,
  useToggleThreadPinMutation,
  useToggleThreadLikeMutation
} = thredService;
